"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDimensions = exports.defaultAngles = exports.defaultMargins = void 0;
exports.defaultMargins = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
exports.defaultAngles = {
    startAngle: 0,
    endAngle: 0,
    startAngleDeg: 0,
    endAngleDeg: 0
};
exports.defaultDimensions = {
    width: 0,
    height: 0,
    margin: exports.defaultMargins,
    outerRadius: 0,
    innerRadius: 0,
    angles: exports.defaultAngles,
    fixedHeight: 0
};
